// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "@/store/index"
// import "lib-flexible"
import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast,Dialog } from 'vant';
import "./assets/css/nav.css";
import Base64 from './secret/index.js' 
import vueWechatTitle from 'vue-wechat-title'
import moment from 'moment'
//引用element
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';//使用
Vue.prototype.$moment = moment
import '@/utils/flexible.js'
import vConsole from '@/utils/vconsole.js'
// Vue.use(vConsole)
Vue.use(vueWechatTitle)
Vue.prototype.$Base64 = Base64;
Vue.prototype.Toast=Toast
Vue.prototype.Dialog=Dialog
Vue.use(Vant).use(Element);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js